<div [formGroup]="frmCreditCheckDetails">
  <div class="center">
    <div>
      <mat-form-field appearance="standard">
        <mat-label>1st Peak Month Usage</mat-label>
        <input id="usage1" matInput maxlength="255" min="1" type="number" formControlName="usage1" />
        <mat-hint *ngIf="!frmCreditCheckDetails?.get('usage1').value"> Enter correct 1st usage value</mat-hint>
        <mat-error *ngIf="frmCreditCheckDetails?.get('usage1').value"> Incorrect 1st usage value</mat-error>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="standard">
        <mat-label>2nd Peak Month Usage</mat-label>
        <input id="usage2" matInput maxlength="255" min="1" type="number" formControlName="usage2" />
        <mat-hint *ngIf="!frmCreditCheckDetails?.get('usage2').value"> Enter correct 2nd usage value</mat-hint>
        <mat-error *ngIf="frmCreditCheckDetails?.get('usage2').value"> Incorrect 2nd usage value</mat-error>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="standard">
        <mat-label>Rate</mat-label>
        <input id="companyName" matInput maxlength="255" min="1" step=".01" type="number" formControlName="rate" />
        <mat-hint *ngIf="!frmCreditCheckDetails?.get('rate').value"> Enter correct rate value</mat-hint>
        <mat-error *ngIf="frmCreditCheckDetails?.get('rate').value"> Incorrect rate value</mat-error>
      </mat-form-field>
    </div>
    <div>
      <button id="quoteBtn" class="credit-check-button" mat-flat-button color="accent" type="button" (click)="performCreditCheck()" [disabled]="!canPerformCreditCheck() || isCreditCheckInProgress || creditCheckResponse || frmCreditCheckDetails.invalid">
        <span class="credit-check-icon" *ngIf="!isCreditCheckInProgress">
          <img src="/assets/icons/icon-money.svg" class="prefix" alt="money-icon" />
        </span>
        <span class="credit-check-spinner" *ngIf="isCreditCheckInProgress">
          <mat-spinner [diameter]="16" color="primary"></mat-spinner>
        </span>
        <span>Run Credit Check</span>
      </button>
      <p *ngIf="statusLabel">
        <img [src]="statusLabel?.icon"
             class="icon-sm"
             aria-hidden="false"
             alt="credit-check-icon" />
        {{statusLabel?.displayStatus}}
      </p>
    </div>
  </div>
  <div class="button-container">
    <button style="margin-left:30px;" class="credit-check-button" mat-flat-button color="accent" type="button" (click)="redo()">
      <span>Redo</span>
    </button>
    <button class="credit-check-button" mat-flat-button color="accent" type="button" (click)="close()">
      <span>Close</span>
    </button>
  </div>
</div>
